import { CFAuthGetRef } from 'auth';
import { locations } from '../../common/redux/action_locations';
import {
  FETCH_SINGLE_OPPORTUNITY,
  MAX_STATUS_ID,
  RECEIVED_SINGLE_OPPORTUNITY,
  CLEAR_SINGLE_OPPORTUNITY,
} from './constants';
import { fetchStatusQuestionsAction } from './fetchStatusQuestions';

export function fetchSingleOpportunityAction(filters) {
  return {
    type: FETCH_SINGLE_OPPORTUNITY,
    fetchCall: fetchSingleOpportunity,
    receivedAction: receivedSingleOpportunity,
    data: {
      locations,
      filters,
    },
  };
}

export function clearSingleOpportunityAction() {
  return {
    type: CLEAR_SINGLE_OPPORTUNITY
  };
}

export function fetchSingleOpportunity(filters) {
  return CFAuthGetRef({
    url: `${process.env.REACT_APP_COACHING_API_URL}/api/CoachingOpportunities/${filters.opportunityId}`,
    params: null,
    originURL: process.env.PUBLIC_URL,
    loaderName: 'fetchSingleOpportunity'
  });
}

export function receivedSingleOpportunity(data) {
  return (dispatch) => {
    const { callLogId, status: { id } } = data;
    const targetStatusId = id + 1;
    if (!callLogId) {
      data.callLogId = '';
    }
    if (targetStatusId <= MAX_STATUS_ID) {
      // since these two actions will always be fired sequentially, abstract this here
      dispatch(fetchStatusQuestionsAction({ statusId: targetStatusId }));
    }

    dispatch({
      type: RECEIVED_SINGLE_OPPORTUNITY,
      data,
    });
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case RECEIVED_SINGLE_OPPORTUNITY:

      let teams = JSON.parse(JSON.stringify(state.teams));
      if (Array.isArray(teams)) {
        action.data.salesAgent.teamLeadTeams.forEach(team => {
          if (teams.every(teamData => teamData.id !== team.id)) {
            teams.push(team);
          };
        });
      } else {
        teams = action.data.salesAgent.teamLeadTeams;
      }

      return {
        ...state,
        teams,
        singleOpportunity: action.data,
      };
    case CLEAR_SINGLE_OPPORTUNITY:
      return {
        ...state,
        singleOpportunity: null,
        opportunityAnswers: null,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/fetchSingleOpportunity.js